import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-pci',
  imports: [RouterLink],
  templateUrl: './pci.html',
  styleUrl: './pci.css',
})
export class Pci {
  features = [
    {
      icon: '🔐',
      title: 'Secure Cardholder Data',
      description: 'Implement robust security measures to protect stored cardholder data with encryption and access controls.'
    },
    {
      icon: '🛡️',
      title: 'Network Security',
      description: 'Build and maintain secure networks with firewalls, network segmentation, and intrusion detection systems.'
    },
    {
      icon: '📋',
      title: 'Compliance Documentation',
      description: 'Comprehensive documentation of security policies, procedures, and compliance evidence for audits.'
    },
    {
      icon: '🔍',
      title: 'Vulnerability Management',
      description: 'Regular vulnerability scanning, penetration testing, and remediation tracking for payment systems.'
    },
    {
      icon: '👥',
      title: 'Access Control',
      description: 'Implement strict access controls and authentication mechanisms for cardholder data environments.'
    },
    {
      icon: '📊',
      title: 'Continuous Monitoring',
      description: 'Real-time monitoring and logging of all access to cardholder data and network resources.'
    }
  ];

  process = [
    {
      number: 1,
      title: 'Gap Assessment',
      description: 'Comprehensive evaluation of current security controls against PCI DSS requirements.'
    },
    {
      number: 2,
      title: 'Remediation Planning',
      description: 'Develop detailed roadmap to address gaps and implement required security controls.'
    },
    {
      number: 3,
      title: 'Implementation',
      description: 'Deploy security controls, update policies, and train staff on PCI DSS compliance.'
    },
    {
      number: 4,
      title: 'Validation & Certification',
      description: 'Complete audit process and achieve PCI DSS compliance certification.'
    }
  ];

  caseStudy = {
    title: 'E-Commerce Platform Achieves PCI DSS Level 1',
    description: 'A rapidly growing e-commerce platform processing $500M annually needed to achieve PCI DSS Level 1 compliance to maintain their payment processing capabilities and customer trust.',
    challenge: 'Legacy infrastructure with inadequate security controls and no formal compliance program',
    solution: 'Comprehensive security overhaul including network segmentation, encryption implementation, and compliance automation',
    industry: 'E-Commerce',
    timeline: '5 Months',
    result: '100% Compliant'
  };

  testimonial = {
    quote: 'HoneyKode transformed our approach to payment security. Their team guided us through every step of PCI DSS compliance, and we now have a robust security framework that protects our customers and our business.',
    author: 'James Mitchell',
    role: 'CTO, SecureCommerce Solutions'
  };
}
